import type { ChatMessage, GameKbArtifacts } from '@sr-test-wizard/shared';
import { api } from './api';

/**
 * Client for the `/api/runs/:id/game-kb` route module (Game Knowledge Base
 * Extras feature). Report generation is fire-and-forget - the page reflects
 * progress from the `game-kb-progress` WS stream and re-fetches artifacts on
 * completion. Chat is synchronous.
 */
export const gameKbApi = {
  get: (runId: string) => api.get<GameKbArtifacts>(`/api/runs/${runId}/game-kb`),
  generateDescription: (runId: string) =>
    api.post<{ started: boolean; alreadyRunning?: boolean }>(
      `/api/runs/${runId}/game-kb/description`,
    ),
  generateReport: (runId: string) =>
    api.post<{ started: boolean; alreadyRunning?: boolean }>(
      `/api/runs/${runId}/game-kb/report`,
    ),
  postDescriptionComment: (runId: string) =>
    api.post<{ texecKey: string; commentId: string; url: string | null }>(
      `/api/runs/${runId}/game-kb/description/post-comment`,
    ),
  proposeConcepts: (runId: string) =>
    api.post<{
      createdDrafts: Array<{ slug: string; canonicalName: string }>;
      brandingsAdded: Array<{ conceptSlug: string; text: string }>;
      skipped: string[];
    }>(`/api/runs/${runId}/game-kb/propose-concepts`),
  listChat: (runId: string) => api.get<ChatMessage[]>(`/api/runs/${runId}/game-kb/chat`),
  sendChat: (runId: string, question: string) =>
    api.post<{ message: ChatMessage }>(`/api/runs/${runId}/game-kb/chat`, { question }),
  resetChat: (runId: string) => api.delete<{ cleared: boolean }>(`/api/runs/${runId}/game-kb/chat`),
};
